export default {
  en: "Inglese",
  fr: "Francese",
  es: "Spagnolo",
  de: "Tedesco",
  it: "Italiano",
  pt: "Portoghese",
  ru: "Russo",
  zh: "Cinese",
  ja: "Giapponese",
  ko: "Coreano",
  ar: "Arabo",
  hi: "Hindi",
  tr: "Turco",
  nl: "Olandese",
  pl: "Polacco",
  sv: "Svedese",
  da: "Danese",
  fi: "Finlandese",
  no: "Norvegese",
  cs: "Ceco",
  hu: "Ungherese",
  ro: "Rumeno",
  bg: "Bulgaro",
  el: "Greco",
  he: "Ebraico",
  th: "Tailandese",
  vi: "Vietnamita",
  id: "Indonesiano",
  ms: "Malese",
  fa: "Persiano"
};

